
export const THREAD_STATUS = {
    PENDING: "Pending",
    OPEN: "Open",
    WAITING_ON_CUSTOMER: "Waiting on Customer",
    RESOLVED: "Resolved",
    CLOSED: "Closed"
}